import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: 'マニュアル不要の市場調査・分析SaaS開発を実現',
  title1: 'マニュアル不要の市場調査・分析SaaS開発を実現',
  company: '株式会社マクロミル',
  introduction_text:
    'アイデア発想を支援するデータプラットフォームSaaS「Coreka（コレカ）」のUX/UI設計全般をサポートしました。このプロダクトは、市場・生活者データを活用し、商品開発におけるアイデア発想を支援するSaaSです。弊社はユーザーのニーズと目的に合わせた最適な情報設計とビジュアルコンセプトの設計に注力しました。',
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  image: '/images/img/cases/coreka/mv.webp',
  movie: '',
  alt: 'マニュアル不要の市場調査・分析SaaS開発を実現',
}

// プロジェクト概要
export const overviewTitle = '商品開発のアイデア発想を支援するSaaS「Coreka」のデザイン支援'

export const overviewItem: OverviewItems[] = [
  {
    text: 'マーケティングという領域は非常に広範ですが、本質的には「ものが売れる仕組みを作ること」を目指しています。その起点となる「ものを作る」フェーズに求められるのは、市場のニーズを的確に捉え、適切なターゲットに向けて商品設計を行うこと。しかし、消費者の深層的なインサイトを理解し、革新的なアイデアを生み出すのは容易ではありません。',
  },
  {
    text: '2025年1月、マクロミル社がリリースした「Coreka（コレカ）」は、同社が保有する130万人規模のパネルを活用し、データ収集・分析からアイデア創出までをサポートします。とりわけ、多様な情報探索モードに対応する洗練されたUX/UIと、直感的な操作性を実現したデザインが特徴です。',
  },
  {
    text: 'Aitriaは、このプロダクト開発において、UX/UI設計全般をサポート。特に、ユーザーのニーズと目的に合わせた最適な情報設計とビジュアルコンセプトの設計に注力しました。',
  },
  {
    text: '今回は、Corekaのプロダクトマネージャーである丹治さん、Aitriaからはプロジェクトマネージャーの今野、デザイン部の部長として監修を務めた佐々木の3名に、開発の背景や成果について伺いました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '労働集約型ビジネスモデルからの脱却',
        text: 'アドホックリサーチで高い売上を上げていたが、労働集約型であるため利益率向上が課題となり、より収益性の高い新たなビジネスモデルの構築が求められていた。',
      },
      {
        title: 'パネルアセットを活かした新規事業の構築',
        text: '同社は自社の大規模なアンケートパネルという柔軟にデータを蓄積できるアセットを保有しており、自社データを生かしたビジネスに大きな可能性があると考えていた。',
      },
      {
        title: '直感的に使えるUX/UIの必要性',
        text: 'SaaS型のツールとして展開するにあたり、導入のハードルが低く、データリテラシーが高くない方でも直感的に使えるUX/UIを実現することが重要だった。',
      },
    ],
    solutions: [
      {
        title: '直感的に使えるUX/UIの設計',
        text: 'SaaSサービスの継続利用を促すため、ユーザーが迷わず操作できるUX/UIを設計。ボタン配置や導線設計を工夫し、初見でも直感的に操作できるインターフェースを構築した。',
      },
      {
        title: '論理的アプローチに基づくデザインの確立',
        text: '論文やリサーチを基にした理論的なデザインアプローチを採用し、納得感のある成果物を提供。',
      },
      {
        title: '情報探索の理論を活かした機能設計',
        text: '人がどのように情報を探し、発想を生み出すのかを分析。その結果をもとに、フィード機能や履歴機能を設計し、直感的で効果的な情報探索を実現した。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '「マニュアルがないと使えないSaaS」になっていませんか？',
  description:
    '論理的なデザインアプローチで、「なぜそのUIなのか」を言語化しながら設計を進めます。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
